module.exports = __webpack_public_path__ + "static/media/icon_incomplete-data-issue.af6fe430.svg";